import Vue from "vue";
import Router from "vue-router";
import { Auth } from "aws-amplify";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "healthassessment",
      component: () => import("./views/Assessment.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/company",
      name: "home",
      component: () => import("./views/Company2022.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/workshop",
      name: "workshop",
      component: () => import("./views/Workshop.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/coaching",
      name: "coaching",
      component: () => import("./views/Coaching.vue"),
      meta: { requiresAuth: true }
    },
    // {
    //   path: "/voucher",
    //   name: "voucher",
    //   component: () => import("./views/Voucher.vue"),
    //   meta: { requiresAuth: true },
    // },
    {
      path: "/login",
      name: "login",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Login.vue")
    }
  ],
  mode: "history"
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user;
    Auth.currentAuthenticatedUser()
      .then(data => {
        if (data && data.signInUserSession) {
          user = data;
          if (typeof to.meta.role !== "undefined") {
            // Roles
            let userRoles =
              user.signInUserSession.accessToken.payload["cognito:groups"];
            let role = to.meta.role;
            let authorised = false;
            for (var i = 0; i < userRoles.length; i++) {
              if (role === userRoles[i]) {
                authorised = true;
              }
            }
            if (!authorised) {
              next({ path: "/login" });
            }
          }
        }
        next();
      })
      .catch(() => {
        next({ path: "/login" });
      });
  }
  next();
});

export default router;
